export var createTenantsPhoneApi = function (baseUrl, http) {
    var url = baseUrl + "/phone";
    var filesApi = {
        enable: function () {
            return http.post(url + "/enable", {});
        },
        disable: function () {
            return http.post(url + "/disable", {});
        },
    };
    return filesApi;
};
//# sourceMappingURL=index.js.map